import getMeetingTypeExtension from '../services/getMeetingTypeExtension';
import { setMeetingTypeExtension } from '../actions/setMeetingTypeExtensions';
import { trace } from 'owa-trace';
/**
 * Triggers a service call to get the booking setMeetingTypeExtensionDetails.
 */
export default async function setMeetingTypeExtensionDetails(meetingId: string) {
    try {
        const meetingTypeExtension = await getMeetingTypeExtension(meetingId);
        setMeetingTypeExtension(meetingTypeExtension);
    } catch (e) {
        trace.warn(e.message || 'syncAllMeetingTypeExtensions failed');
    }
}
